/* Assign new templates to Klevu Options (uncomment for manual integration) */
klevu({
	theme: {
		setTemplates: {
            customProductBlock: {
				scope: 'landing,catnav', // impacted scope
				selector: '#myCustom_klevuLandingTemplateProductBlock', // new markup block ID
				name: 'productBlock' // template placement name
			},
          customNoResultsFoundPopularProducts: {
               scope: 'landing',
               selector: '#myCustom_klevuNoResultsPopularProductsLanding',
               name: 'noResultsLandingPopularProductsTemplate'
            }
		}
	}
}); 

    klevu.dom.helpers.addElementToHead({
      name: "cssToFixpriceRange",
      content: '.klevuLanding.kuSearchResultsPageContainer .kuFilters .kuFilterBox.klevuFilter[data-filter="Price Range"] .kuFilterNames ul li a.klevuFilterOption {display: flex !important;}',
      type: "css"
    });

    klevu.modifyResponse('landing, catnav', function (data) {

      var kmcData = klevu.getObjectPath(klevu.search, "modules.kmcInputs.kmcData.klevu_uc_userOptions.priceFormatter", undefined);

      var priceFormatter =
        (typeof klevu_uc_userOptions !== "undefined" && klevu_uc_userOptions.priceFormatter) ?
          klevu_uc_userOptions.priceFormatter :
          kmcData;

      if (!klevu.isUndefined(data.template.query["productList"])) {
        const productList = data.template.query["productList"];

        productList.filters.forEach(function (filter) {
          if (filter.key.toLowerCase() === "price range") {
            filter.options.forEach(function (option) {
              formatPriceRangeOption(option, priceFormatter);
            });
          }
        });
      }
    });

    function formatPriceRangeOption(option, formatter) {
      if (!formatter) return; // Exit if no formatter is available

      const [minPrice, maxPrice] = option.name.replace(/\s/g, "").split("-").map(price => price.trim());
      const formattedMinPrice = formatPrice(minPrice, formatter);
      const formattedMaxPrice = maxPrice ? formatPrice(maxPrice, formatter) : '';
      option.name = formattedMaxPrice ? `${formattedMinPrice} - ${formattedMaxPrice}` : formattedMinPrice;
    }

    function formatPrice(price, { appendCurrencyAtLast, currencySymbol }) {
      return appendCurrencyAtLast ? `${price}${currencySymbol}` : `${currencySymbol}${price}`;
    }

//page meta override for Also Bought Recs

document.addEventListener('DOMContentLoaded', function () {
        fetch('/cart.js')
          .then((response) => response.json())
          .then((cart) => {
            window.klevu_shopify_cart = cart;
          })
          .catch((error) => console.error('Error fetching cart data:', error));

        const miniBagItems = document.querySelectorAll('a.js-drawer-open-cart');
        miniBagItems.forEach(function (item) {
          item.addEventListener('click', function () {
            if (typeof klevu_page_meta === 'undefined') {
              window.klevu_page_meta = {};
            }
            klevu_page_meta.pageType = 'cart';
            klevu_page_meta.cartRecords = [];

            klevu_shopify_cart.items.forEach((item) => {
              klevu_page_meta.cartRecords.push({ itemId: item.id, itemGroupId: item.product_id });
            });

            console.log('klevu_page_meta', klevu_page_meta.cartRecords);

            klevu.pageMeta.update(klevu_page_meta, 1);

            klevu.each(klevu.dom.find('.klevu-recs-addtocart'), function (key, recsTargetElement) {
              if (!recsTargetElement.id) {
                console.info('No Klevu RECS ID found on the targeted element!', recsTargetElement);
                return;
              }

              var found = false;
              klevu.each(klevu.recs.list, function (key, rec) {
                if (rec.getScope().element === recsTargetElement) {
                  found = true;
                }
              });

              if (!found) {
                klevu.recs.clone({
                  recId: recsTargetElement.id,
                  apiKey: 'klevu-171836577623717383',
                  element: recsTargetElement,
                });
              }
            });

            var recsList = klevu.recs.list;
            if (recsList && recsList.length) {
              klevu.each(recsList, function (key, recsObj) {
                if (recsObj.getScope().element.classList.contains('klevu-recs-addtocart')) {
                  recsObj.powerUp();
                }
              });
            }
          });
        });
      });